export const TRACK = "@usage-track/TRACK";
export const FLUSH_TRACK_DATA = "@usage-track/FLUSH_TRACK_DATA";
export const CLEAR_TRACK_DATA = "@usage-track/CLEAR_TRACK_DATA";
export const TAG_MANAGER_DATA_LAYER_LOADED = "@usage-track/TAG_MANAGER_DATA_LAYER_LOADED";
